import type { ComponentProps } from 'react'

import {
  ModalContent,
  ModalSplitLayout,
  useIsInModal,
} from '@twisto/components/atoms/modal'

import * as styles from './bank-accounts-layout.styles'

type Props = ComponentProps<typeof ModalSplitLayout>

export const BankAccountsLayout = ({ start, end }: Props) => {
  const isCalledInModal = useIsInModal()

  if (isCalledInModal) {
    return (
      <ModalSplitLayout
        end={<ModalContent css={styles.modalContent}>{end}</ModalContent>}
        start={<ModalContent css={styles.modalContent}>{start}</ModalContent>}
      />
    )
  }

  return (
    <>
      <div css={styles.modalContent}>{start}</div>
      <div css={styles.modalContent}>{end}</div>
    </>
  )
}
